import { attach, createEffect, createEvent, createStore, restore } from 'effector'

import { getCarsFx } from '../../../api/cars'
import { getCities } from '../../../api/cities'
import { getFromStorage } from '../../../lib/storage'

export const userSelectedCity = createEvent<string[]>()
export const $cityFromLocalStorage = restore(userSelectedCity, null)

export const fetchCitiesFx = createEffect(getCities)

/**
 * Общее количество машин по фильтру
 */
export const $totalCount = createStore<number>(0)

/** Получить города из Локалстораджа **/
export const getFromStorageFx = createEffect(async () => {
  const cities = getFromStorage('citySelectselectedCities')

  if (!cities) throw new Error('No cities found in localstorage ')
  return cities
})

/** Получить города из Локалстораджа, при этом,
 *  если город найден в локалстораджах,
 *  но не все найденые города могут быть выбраны,
 *  полностью инвалидируем выбор и считаем, что попытка достать города из локалстораджа провалилась
 */
export const getValidCityFromStorageFx = createEffect(async (allCities: string[]) => {
  const cities = await getFromStorageFx()

  if (!cities.every((city: string) => allCities.includes(city)))
    throw new Error(
      'Cities was found in localstorage but cannot be applied because not all saved cities are available for selection'
    )

  return cities
})

export const fetchWidgetCarsFx = attach({
  effect: getCarsFx
})
